import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ActivityHeader from './ActivityHeader'
import ActivityView from './ActivityView'
import UserActivityControlPanelActivityActions from './UserActivityControlPanelActivityActions'
import ActivityInfo from './ActivityInfo'

import './styles.scss'
const bc = 'user-activity'

export default class UserActivityControlPanel extends Component {
  static propTypes = {
    isActionsAvailable: PropTypes.bool,
    activityName: PropTypes.string,
    activityId: PropTypes.number,
    highlightFavoriteIcon: PropTypes.bool,
  }

  state = {
    isExpanded: true,
  }

  handleToggleExpand = () => this.setState(({ isExpanded }) => ({ isExpanded: !isExpanded }))

  render() {
    const { isExpanded } = this.state
    const { t, activityName, activityId, highlightFavoriteIcon } = this.props
    const activityTitle = `${t('Today’s Activity')} - ${activityName}`

    return (
      <div
        className={classNames(bc, {
          [`${bc}--hidden`]: !isExpanded,
        })}
        id="user-activity-control-panel"
      >
        <ActivityHeader
          onHide={this.handleToggleExpand}
          isExpanded={isExpanded}
          activityId={activityId}
          highlightFavoriteIcon={highlightFavoriteIcon}
          activityTitle={activityTitle}
        />
        {isExpanded && (
          <Fragment>
            <div className={`${bc}__top`}>
              <div className={`${bc}__title`} title={activityName}>
                {activityTitle}
              </div>
            </div>
            <div>
              <ActivityInfo />
              <ActivityView />
              <UserActivityControlPanelActivityActions />
            </div>
          </Fragment>
        )}
      </div>
    )
  }
}
